<template>
  <div>
    <div v-if="fetchingClient">
      <b-alert show variant="info" class="cca-banner">
        <b-spinner small type="grow" />
        <span class="ml-2">Obteniendo información del cliente...</span>
      </b-alert>
    </div>

    <ClientSearch
      :clientOptional="false"
      :clientSelected="client"
      :disable-input="fetchingClient"
      @select-client="handleSelectClient"
      @reset-client="resetClient"
      @set-no-client="setNoClient"
    />

    <div>
      <ValidationProvider :rules="{ required: true, max: 100, min: 5 }" name="nombre del cliente" v-slot="{ errors }">
        <b-form-group class="mt-2 mb-0">
          <template #label>
            <span>Nombre del cliente</span><span class="asterisk">*</span>
          </template>
          <b-input
            v-model="clientForm.client_name"
            type="text"
            disabled
            placeholder="Nombre del cliente"
            :state="(errors[0] || !clientForm.client_id) ? false : true"
          />
        </b-form-group>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import ClientSearch      from '../../../../shared/ClientSearchV2'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'ClientForm',
  components: { ClientSearch, ValidationProvider },
  props: {
    clientSelected: { type: Object, default: () => {} },
    clientForm: { type: Object, required: true },
  },
  data() {
    return {
      clientFetched: {},
      fetchingClient: false,
    }
  },
  computed: {
    client () {
      return this.clientSelected || this.clientFetched || {}
    }
  },
  methods: {
    handleSelectClient (selected) {
      this.clientFetched = { ...selected }
      this.clientForm.client_id   = selected.id
      this.clientForm.client_code = selected.client_num
      this.clientForm.client_name = selected.name
      this.clientForm.payment_terms = selected.payment_terms
      this.$emit('client-selected', selected)
    },
    resetClient () {
      this.clientFetched = {}
      this.clientForm.client_id   = null
      this.clientForm.client_code = null
      this.clientForm.client_name = null
      this.$emit('client-reset')
    },
    setNoClient () {
      this.resetClient()
    }
  }
}
</script>

<style scoped>
  .cca-banner {
    display: flex; align-items: center; gap: 8px;
    padding: 8px 12px; border-radius: 8px;
    font-size: 0.78rem; margin-bottom: 8px; min-height: 36px;
  }
  .cca-undo-btn {
    margin-left: auto; background: none; border: none;
    color: #e8380d; font-size: 0.78rem; font-weight: 600;
    cursor: pointer; text-decoration: underline; padding: 0;
  }
  .asterisk { color: #dc2626; margin-left: 2px; }
</style>
